export default __webpack_public_path__ + "static/media/backgroundgenerator.f1fe4125.png";